import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { DispatchCenterService } from 'src/app/component/dashboard/dashboard-service/dispatch-center-service';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { getDistanceFromLatLonNew } from 'src/app/utils/utils.common';
import * as _ from 'lodash';
import * as moment from 'moment-timezone';
import { interval } from 'rxjs';

@Component({
  selector: 'app-dispatch-driver-trips-modal',
  templateUrl: './dispatch-driver-trips-modal.component.html',
  styleUrls: ['./dispatch-driver-trips-modal.component.css']
})

export class DispatchDriverTripsModalComponent implements OnInit, OnDestroy {
  @Input() source?: any;
  @Input() driverId;
  @Input() date?: any;
  @Output() close = new EventEmitter<any>();
  search;
  trips = [];
  routePoints = [];
  preLevelOfServices = {};
  preSpaceTypes = {};
  preCooperates = {}
  driverDetails: any;
  isGoogleMiles = false;
  user: any;
  cancelTripModalObj = null;
  isMarkComplete = false;
  isNoShow = false;
  allowInprogressTripReassign = false;
  assignModalObj: any;
  secondaryCompType = null;
  componentType: any;
  todayDate: any;
  addOverrideShiftModalObj: any = null;
  @Output() saveOverrideShift = new EventEmitter<any>();

  constructor(
    private corporateService: CorporateService,
    private levelOfServiceService: LevelOfServiceService,
    private dispatchCenterService: DispatchCenterService,
    private driverService: DriversService,
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.sharedDataService.getUser().subscribe(user => {
      this.user = user;
    });
    this.getLevelOfService();
    this.getSpaceTypes();
    this.getDriverTrips();
    this.getCorporate();
    this.getUser();

    interval(10000)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(() => {
        if (!this.cancelTripModalObj) {
          this.getDriverTrips();
        }
      });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.user.hasOwnProperty("allowInprogressTripReassign") && this.user.allowInprogressTripReassign) {
            this.allowInprogressTripReassign = this.user.allowInprogressTripReassign;
          }
          this.todayDate = [
            moment.tz(this.user.timeZone).startOf("day").toISOString(),
            moment.tz(this.user.timeZone).endOf("day").toISOString(),
          ];
        }
      });
  }

  closeModal() {
    if (this.cancelTripModalObj || this.isMarkComplete || this.assignModalObj) return;
    this.close.emit();
  }

  getDriverTrips() {
    const payload = {
      driverId: this.driverId,
      status: 'all',
      isTrack: true
    }
    if (this.date) {
      payload['scheduleTime'] = this.date[0];
    }
    this.dispatchCenterService.getDriverTrips(payload).subscribe(data => {
      if (data) {
        this.trips = data.assigns;
        this.getDriverDetails();
      }
    })
  }

  getDriverDetails() {
    if (this.driverId) {
      this.driverService.getDriversByID(this.driverId)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(driver => {
          this.driverDetails = driver;
          this.processTrips(driver);
        }, err => {
          console.error('Error fetching driver details', err);
          this.processTrips();
        });
    } else {
      this.processTrips();
    }
  }

  onChangeAlgorithm() {
    this.processTrips();
  }

  async processTrips(driver?: any) {
    const points = [];
    this.routePoints = [];
    if (this.trips && this.trips.length) {
      // Determine starting point: use current GPS if available, else garage
      if (driver) {
        const tz = this.user ? this.user.timeZone : moment.tz.guess();
        const now = moment().tz(tz);

        let startLat = null;
        let startLng = null;
        let startAddress = 'Starting Point';
        let isUsingGPS = false;

        if (driver.latitude != null && driver.longitude != null) {
          startLat = driver.latitude;
          startLng = driver.longitude;
          startAddress = 'Current Driver Location';
          isUsingGPS = true;
        } else if (driver.startingPointAddress && driver.startingPointAddress.latitude != null) {
          startLat = driver.startingPointAddress.latitude;
          startLng = driver.startingPointAddress.longitude;
          startAddress = driver.startingPointAddress.address || 'Garage';
        }

        if (startLat != null) {
          points.push({
            type: 'GARAGE_START',
            time: this.date ? this.date[0] : now.toISOString(),
            actualTime: isUsingGPS ? now.toISOString() : null,
            address: startAddress,
            latitude: startLat,
            longitude: startLng,
            trip: {
              priorityClient: { displayName: startAddress },
              jobStatus: ''
            },
            isLate: false,
            lateDuration: ''
          });
        }
      }
      this.trips.forEach(trip => {
        if (trip.status === 'cancelled' && !trip.job) return;

        // Pickup Point
        points.push({
          type: 'PICKUP',
          time: trip.scheduleTime,
          actualTime: (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobArrived && trip.job.trackInfoJob.jobArrived.time) ? trip.job.trackInfoJob.jobArrived.time : (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCancelled && trip.job.trackInfoJob.jobCancelled.time) ? trip.job.trackInfoJob.jobCancelled.time : (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobStarted && trip.job.trackInfoJob.jobStarted.time) ? trip.job.trackInfoJob.jobStarted.time : null,
          address: trip.jobOriginAddress,
          latitude: trip.jobOriginLatitude,
          longitude: trip.jobOriginLongitude,
          trip: trip,
          ...this.calculateLateStatus(trip.scheduleTime, trip.jobStatus, 'PICKUP')
        });
        if (trip.status !== 'cancelled') {
          // Dropoff Point
          points.push({
            type: 'DROPOFF',
            time: trip.appointmentTime,
            actualTime: (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCompleted && trip.job.trackInfoJob.jobCompleted.time) ? trip.job.trackInfoJob.jobCompleted.time : (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobFinished && trip.job.trackInfoJob.jobFinished.time) ? trip.job.trackInfoJob.jobFinished.time : (trip.job && trip.job.trackInfoJob && trip.job.trackInfoJob.jobCancelled && trip.job.trackInfoJob.jobCancelled.time) ? trip.job.trackInfoJob.jobCancelled.time : null,
            address: trip.jobDestinationAddress,
            latitude: trip.jobDestinationLatitude,
            longitude: trip.jobDestinationLongitude,
            trip: trip,
            ...this.calculateLateStatus(trip.appointmentTime, trip.jobStatus, 'DROPOFF')
          });
        }

      });
      // Sort by time and specific completion status
      this.routePoints = points.sort((a, b) => {
        // 1. Garage Start always first
        if (a.type === 'GARAGE_START') return -1;
        if (b.type === 'GARAGE_START') return 1;

        // 2. Point-specific completion logic
        const getCompletionStatus = (p) => {
          if (!p.trip || !p.trip.jobStatus) return false;
          const status = p.trip.jobStatus.toLowerCase();
          if (p.type === 'PICKUP') return ['arrived', 'cancelled', 'started', 'finished', 'completed'].includes(status);
          if (p.type === 'DROPOFF') return ['finished', 'completed', 'cancelled'].includes(status);
          return false;
        };

        const isACompleted = getCompletionStatus(a);
        const isBCompleted = getCompletionStatus(b);

        if (isACompleted && !isBCompleted) return -1;
        if (!isACompleted && isBCompleted) return 1;

        // 3. Sort by pickupOrder/dropOffOrder if already exists
        const posA = a.type === 'PICKUP' ? a.trip.pickupOrder : a.type === 'DROPOFF' ? a.trip.dropOffOrder : undefined;
        const posB = b.type === 'PICKUP' ? b.trip.pickupOrder : b.type === 'DROPOFF' ? b.trip.dropOffOrder : undefined;

        if (posA !== undefined && posB !== undefined && posA !== null && posB !== null) {
          if (posA !== posB) return posA - posB;
        }

        // 4. Chronological within groups
        const timeA = new Date(a.time).getTime();
        const timeB = new Date(b.time).getTime();
        if (timeA !== timeB) return timeA - timeB;

        // 5. Type Order: PICKUP first, then DROPOFF
        if (a.type === 'PICKUP' && b.type === 'DROPOFF') return -1;
        if (a.type === 'DROPOFF' && b.type === 'PICKUP') return 1;

        return 0;
      });
      // 1. Assign completion status for UI
      this.routePoints.forEach((point) => {
        if (point.trip && point.trip.jobStatus) {
          const status = point.trip.jobStatus.toLowerCase();
          if (point.type === 'PICKUP') {
            point.isCompleted = ['arrived', 'cancelled', 'started', 'finished', 'completed'].includes(status);
          } else if (point.type === 'DROPOFF') {
            point.isCompleted = ['finished', 'completed', 'cancelled'].includes(status);
          }
        }
      });



      // 4. Garage dims if any trip has started/completed
      const hasAnyCompleted = this.routePoints.some(p => p.type !== 'GARAGE_START' && p.isCompleted);
      const garagePoint = this.routePoints.find(p => p.type === 'GARAGE_START');
      if (garagePoint) {
        garagePoint.isCompleted = hasAnyCompleted;
      }

      // 6. Calculate Predicted ETAs and Update Lateness
      const tz = this.user ? this.user.timeZone : moment.tz.guess();
      let predictedTime = moment().tz(tz);
      if (this.date && moment(this.date[0]).tz(tz).isAfter(predictedTime)) {
        predictedTime = moment(this.date[0]).tz(tz);
      }

      let lastNonBreakPoint = null;

      for (let i = 0; i < this.routePoints.length; i++) {
        const point = this.routePoints[i];
        const isBreak = point.type === 'BREAK' || (point.trip && point.trip.isBreakTrip);

        if (point.isCompleted && point.actualTime) {
          predictedTime = moment(point.actualTime).tz(tz);
          point.predictedETA = isBreak ? null : predictedTime.toDate();
          if (!isBreak) {
            lastNonBreakPoint = point;
          }
          continue;
        }

        // Handle BREAK logic
        if (isBreak) {
          point.predictedETA = null;
          point.isLate = false;
          point.lateDuration = '';
          point.distanceToNext = 0;
          // We don't add break duration to predictedTime if we are skipping it in the chain
          continue;
        }

        // Non-break upcoming points
        const isToday = !this.date || moment(this.date[0]).isSame(moment(), 'day');
        if (isToday && predictedTime.isBefore(moment().tz(tz))) {
          predictedTime = moment().tz(tz);
        }

        const distanceInfo = !lastNonBreakPoint
          ? { distance: 0, duration: 0 }
          : await this.calculateDistance(lastNonBreakPoint.latitude, lastNonBreakPoint.longitude, point.latitude, point.longitude);

        const travelTimeMins = distanceInfo.duration;
        const serviceTimeMins = (i === 0) ? 0 : 5;

        // 1. Calculate Arrival Time (Travel only)
        predictedTime = predictedTime.clone().add(travelTimeMins, 'minutes');

        // 2. Floor logic: If we arrive earlier than scheduled, wait until scheduled time
        if (predictedTime.isBefore(moment(point.time))) {
          predictedTime = moment(point.time).tz(tz);
        }

        point.predictedETA = predictedTime.toDate();

        // 3. Add Service Time (Buffer at stop) for the next leg's departure
        predictedTime = predictedTime.clone().add(serviceTimeMins, 'minutes');

        if (lastNonBreakPoint) {
          lastNonBreakPoint.distanceToNext = distanceInfo.distance;
        }

        lastNonBreakPoint = point;

        // Calculate lateness
        const refTime = point.predictedETA;
        if (refTime) {
          const lateness = this.calculateLateStatus(point.time, point.trip ? point.trip.jobStatus : null, point.type, new Date(refTime));
          point.isLate = lateness.isLate;
          point.lateDuration = lateness.lateDuration;
        }
      }

      // Final pass to ensure completed point lateness is correct
      this.routePoints.forEach(point => {
        const isBreak = point.type === 'BREAK' || (point.trip && point.trip.isBreakTrip);
        if (isBreak) {
          point.isLate = false;
          point.lateDuration = '';
          point.predictedETA = null; // Ensure upcoming breaks also have no ETA
        } else if (point.isCompleted && point.actualTime) {
          const lateness = this.calculateLateStatus(point.time, point.trip ? point.trip.jobStatus : null, point.type, new Date(point.actualTime));
          point.isLate = lateness.isLate;
          point.lateDuration = lateness.lateDuration;
        }
      });

      // Auto-scroll to first active trip
      setTimeout(() => {
        const activeElement = document.getElementById('active-trip-anchor');
        if (activeElement) {
          activeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 500);
    }

  }

  async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.isGoogleMiles) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLonNew(lat1, lon1, lat2, lon2)) });
    }
    return resutl;
  }

  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assignTripService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: Math.floor(segments[0].duration / 60)
    };
  }

  calculateLateStatus(scheduledTime, status, type, comparisonTime?: Date) {
    if (!scheduledTime) return { isLate: false, lateDuration: '' };

    const now = comparisonTime || new Date();
    const scheduled = new Date(scheduledTime);
    const diffMs = now.getTime() - scheduled.getTime();

    const completedStatuses = ['completed', 'cancelled', 'finished'];
    if (diffMs > 0 && type !== 'GARAGE_START' && !completedStatuses.includes(status.toLowerCase())) {
      const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
      const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      let duration = '';
      if (diffHrs > 0) duration += `${diffHrs} Hrs `;
      if (diffMins > 0) duration += `${diffMins} Min`;
      return { isLate: true, lateDuration: duration.trim() };
    }

    return { isLate: false, lateDuration: '' };
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      })
  }


  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .subscribe(data => {
        if (data) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  cancelTrip(trip) {
    this.cancelTripModalObj = trip;
  }

  onCancelTrip(evt) {
    if (evt) {
      const index = this.trips.findIndex(
        (trip) => trip._id === evt._id
      );
      this.trips.splice(index, 1);
      this.processTrips(this.driverDetails);
    }
    this.cancelTripModalObj = null;
  }

  markComplete(trip) {
    this.isMarkComplete = true;
    sweetAlert(
      "Alert",
      "Are you sure you want to complete this trip?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService
          .markCompletedTrip(trip)
          .pipe(takeUntil(componentDestroyed(this)))
          .subscribe((data) => {
            if (data) {
              const idx = this.trips.findIndex(t => t._id === trip._id);
              if (idx > -1) {
                this.trips[idx].status = data.status;
                this.trips[idx].jobStatus = data.status;
                this.trips[idx].trackId = data.trackId;
              }
            }
            this.processTrips(this.driverDetails);
            this.isMarkComplete = false;
          });
      }
    });
  }

  updatePriorities() {
    const orderMap = {};
    this.routePoints.forEach((point, idx) => {
      if (point.trip && point.trip._id) {
        if (!orderMap[point.trip._id]) orderMap[point.trip._id] = {};
        if (point.type === 'PICKUP') orderMap[point.trip._id].pickupOrder = idx;
        if (point.type === 'DROPOFF') orderMap[point.trip._id].dropOffOrder = idx;
      }
    });

    this.routePoints.forEach((point, idx) => {
      if (point.trip && point.trip._id && orderMap[point.trip._id]) {
        point.trip.pickupOrder = orderMap[point.trip._id].pickupOrder;
        point.trip.dropOffOrder = orderMap[point.trip._id].dropOffOrder;
      }
    });

    const payload = [];
    const seenIds = new Set();
    this.routePoints.forEach((point, idx) => {
      // Skip Garage Start (first)
      if (idx === 0) return;

      if (point.trip && point.trip._id && !seenIds.has(point.trip._id)) {
        payload.push({
          selectedTrips: [point.trip._id],
          pickupOrder: point.trip.pickupOrder,
          dropOffOrder: point.trip.dropOffOrder,
          driver: { _id: this.driverId, displayName: this.driverDetails ? this.driverDetails.displayName : '' },
          type: 'dnd'
        });
        seenIds.add(point.trip._id);
      }
    });

    this.processTrips(this.driverDetails);

    if (payload.length > 0) {
      this.assignTripService.updateTripsOrders({ data: payload }).subscribe(
        () => {
          console.log('Priorities updated successfully');
          // Re-process trips to update distances etc.
          this.processTrips(this.driverDetails);
        },
        (error) => {
          console.error('Error updating priorities', error);
          sweetAlert('Error', 'Failed to update trip priorities', 'error', 'Ok');
        }
      );
    }
  }

  pullBackFarmoutModalObj: any = null;

  pullBackFarmoutTrip(trip: any) {
    this.pullBackFarmoutModalObj = trip;
  }

  onPullBackFarmoutTrip(evt: any) {
    this.pullBackFarmoutModalObj = null;
    if (evt) {
      this.getDriverTrips();
    }
  }

  assingTripsConditions(assign) {
    let isAllowToView = false;
    if (
      assign.status !== 'finished' &&
      !assign.isJClone &&
      !assign.farmout
    ) {
      if (assign.status === 'inprogress') {
        if (this.allowInprogressTripReassign) {
          isAllowToView = true;
        }
      } else if (['cancelled', 'archived'].includes(assign.status) && assign.job) {
        isAllowToView = false;
      } else {
        isAllowToView = true;
      }
    }
    return isAllowToView;
  }

  setModalContent(trip, type) {
    this.assignModalObj = trip;
    this.componentType = type;
  }

  tripAssignedResponse(evt: any): void {
    const { _id } = this.assignModalObj;
    const idx = this.trips.findIndex(t => t._id === _id);
    this.trips.splice(idx, 1);
    this.processTrips(this.driverDetails);
    this.assignModalObj = null;
  }

  onTripDropped(event: CdkDragDrop<any[]>) {
    const movedPoint = this.routePoints[event.previousIndex];
    if (movedPoint && movedPoint.trip && movedPoint.trip.farmout) {
      return;
    }
    const lastIndex = this.routePoints.length - 1;

    // Prevent moving the first item (Garage Start)
    // And prevent dropping anything into the first slot
    if (event.currentIndex === 0) {
      sweetAlert('Invalid Move', 'You cannot move a trip point before the driver\'s starting point (Garage).', 'warning', 'Ok');
      return;
    }

    if (event.previousIndex === 0) {
      return;
    }

    if (event.previousIndex === event.currentIndex) {
      return;
    }

    // Prevent moving trip before completed trip point
    let lastCompletedIndex = -1;
    this.routePoints.forEach((point, idx) => {
      if (point.isCompleted) {
        lastCompletedIndex = idx;
      }
    });

    if (event.currentIndex <= lastCompletedIndex) {
      sweetAlert('Invalid Move', 'You cannot move a trip point before or into a completed trip point.', 'warning', 'Ok');
      return;
    }

    const movedItem = this.routePoints[event.previousIndex];

    if (movedItem.type === 'DROPOFF') {
      const pickupIndex = this.routePoints.findIndex(t => t.trip && t.trip._id === movedItem.trip._id && t.type === 'PICKUP');
      if (event.currentIndex <= pickupIndex) {
        sweetAlert('Invalid Sequence', 'A drop-off point cannot be scheduled before its corresponding pickup point.', 'warning', 'Ok');
        return;
      }
    }

    if (movedItem.type === 'PICKUP') {
      const dropOffIndex = this.routePoints.findIndex(t => t.trip && t.trip._id === movedItem.trip._id && t.type === 'DROPOFF');
      if (event.currentIndex >= dropOffIndex) {
        sweetAlert('Invalid Sequence', 'A pickup point cannot be scheduled after its corresponding drop-off point.', 'warning', 'Ok');
        return;
      }
    }

    moveItemInArray(this.routePoints, event.previousIndex, event.currentIndex);
    this.updatePriorities();
  }

  openAddShiftModal() {
    const tz = this.user ? this.user.timeZone : moment.tz.guess();
    const now = moment().tz(tz);
    const selectedDate = this.date ? this.date[0] : now.toISOString();
    this.addOverrideShiftModalObj = {
      driverId: this.driverId,
      selectedDate: selectedDate
    };
  }

  onSaveOverrideShift(evt) {
    this.saveOverrideShift.emit(evt);
    this.addOverrideShiftModalObj = null
  }

  ngOnDestroy(): void { }

}

